import { Link } from 'react-router';
import { ThemesTable } from '../components/ThemesTable';
import { Notice } from '../components/Notice';
import { useFlashNotice } from '../hooks/useFlashNotice';

export const Themes = () => {
  const [notice] = useFlashNotice();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-xl font-semibold text-gray-900">Program themes</h1>
        <Link
          to="/themes/new"
          className="py-2 px-4 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition-colors"
        >
          New theme
        </Link>
      </div>
      {notice && <Notice tone="success">{notice}</Notice>}
      <ThemesTable />
    </div>
  );
};
